// @flow
import type { ParsedDateType, BigDateType } from 'parsing-helper'
import type { DailyItemsType } from 'database-helper'

const DATE_LENGTH = 8
const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December'
]
const MONTHS_LENGTH = {
  'January': 31,
  'February': 28,
  'March': 31,
  'April': 30,
  'May': 31,
  'June': 30,
  'July': 31,
  'August': 31,
  'September': 30,
  'October': 31,
  'November': 30,
  'December': 31
}

export const parseDate = (date: string): ParsedDateType => {
  const shortDate = date.substring(0, DATE_LENGTH)
  const year = shortDate.substring(0, 4)
  const month = shortDate.substring(4, 6)
  const day = shortDate.substring(6, 8)
  const formattedMonth = MONTHS[Number(month) - 1]
  return {
    shortDate,
    year,
    month,
    day,
    formattedMonth
  }
}

export const getShortMonth = (month: string): string => (
  month.slice(0, 3)
)

export const getMonthsFromNow = (date: string): Array<string> => {
  const parsedDate = parseDate(date)
  const endMonths = MONTHS.slice(Number(parsedDate.month), MONTHS.length).reverse()
  const begMonths = MONTHS.slice(0, Number(parsedDate.month)).reverse()
  const months = [...begMonths, ...endMonths]
  return months
}

export const getPercentOfMonth = (date: string): number => {
  const parsedDate = parseDate(date)
  const monthLength = MONTHS_LENGTH[parsedDate.formattedMonth]
  return Number(parsedDate.day) * 100 / monthLength 
}

export const daysSinceMonthStarted = (date: string): number => {
  const parsedDate = parseDate(date)
  const monthLength = MONTHS_LENGTH[parsedDate.formattedMonth]
  return (monthLength - Number(parsedDate.day)) || 1
}

export const stringToHTML = (str: string, quoteRegex: RegExp, replace: [string, string]): string => {
  let counter = 0

  const getGoodStr = (s: string): string => {
    if (s.match(quoteRegex)) {
      const toReplace = counter % 2 ? replace[1] : replace[0]
      counter += 1
      return getGoodStr(s.replace(quoteRegex, toReplace))
    }
    return s
  }
  
  return getGoodStr(str)
}

export const removePonctuationAfterTag = (str: string): string => (
  str.match(/<\/i>[.,!?:-]/) ? removePonctuationAfterTag(str.replace(/<\/i>[.,!?:-]/, '</i>')) : str
)

export const getMostRecentArticle = (articles: DailyItemsType): string => {
  const itemKeys = Object.keys(articles)
  return itemKeys[itemKeys.length - 1]
}

const getSup = (day: string): 'st' | 'nd' | 'rd' | 'th' => {
  if (day.match(/(11|12|13)/)) return 'th'
  if (day.match(/\d1/)) return 'st'
  if (day.match(/\d2/)) return 'nd'
  if (day.match(/\d3/)) return 'rd'
  return 'th'
}

export const dateToBigDate = (date: string): BigDateType => {
  const parsedDate = parseDate(date)
  const sup = getSup(parsedDate.day)
  return { day: parsedDate.day, month: parsedDate.formattedMonth, sup }
}


// WEBPACK FOOTER //
// ./src/utils/parsingUtils.js